import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  getAppExclusions, deleteAppExclusion,
  postAppExclusion, searchAppExclusion
} from '../../../../redux/actions'

import {
  Card, Grid, FormLabel,
  CardContent, Button, InputBase,
  InputAdornment, Fab, IconButton,
  TextField
} from '@material-ui/core'

import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'

import { Toast as NotificationToast, ConfirmToast } from '../../tools'
// import { BaseToast } from '../../tools/Toast'
import { handleTextPrepper } from '../../../../utils'

import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 350,
    maxWidth: 350,
    marginTop: '2rem'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: theme.spacing(3)
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#A4D164'
    }
  },
  cssLabel: {
    '&$cssFocused': {
      color: '#A4D164'
    }
  },
  cssFocused: {},
  roleCard: {
    width: '96%'
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    marginTop: '2rem'
  },
  deleteBtn: {
    backgroundColor: '#e57373',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#d05b5b'
    }
  },
  saveBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '75%',
    marginLeft: 'auto',
    marginRight: '.3rem',
    marginBottom: '.5rem'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  appContainer: {
    maxHeight: '37em',
    width: '100%',
    padding: theme.spacing(2, 0),
    marginLeft: 'auto',
    marginRight: 'auto',
    // overflowX: 'hidden',
    overflowY: 'scroll'
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

/**
 * Returns application exclusion form
 */
const AppExclusionList = () => {
  const appExclusions = useSelector(state => state.appExclusions.appExclusions)

  const [newApplicationExe, setNewApplicationExe] = useState('')
  const [newApplicationLabel, setNewApplicationLabel] = useState('')
  const [newApplicationDescription, setNewApplicationDescription] = useState('')
  const [selectedExclusions, setSelectedExclusions] = useState(appExclusions)

  const dispatch = useDispatch()
  const classes = useStyles()
  const textClasses = useTextStyles()

  const [searchVal, setSearchVal] = useState('')

  useEffect(() => {
    dispatch(getAppExclusions())
  }, [dispatch])

  useEffect(() => {
    setSelectedExclusions(appExclusions)
  }, [appExclusions])

  // const fireSuccess = () => {
  //   NotificationToast(false, 'Successfully Added Application Exclusion!')
  //   setNewApplicationLabel('')
  //   setNewApplicationExe('')
  //   setNewApplicationDescription('')
  //   dispatch(getAppExclusions())
  // }

  // const fireFailure = () => {
  //   NotificationToast(true, 'Failed to Add Application Exclusion.')
  // }

  const addApplication = async (newApplicationLabel, newApplicationExe, newApplicationDescription) => {
    const label = handleTextPrepper(newApplicationLabel)
    const exe = handleTextPrepper(newApplicationExe)
    const description = handleTextPrepper(newApplicationDescription)

    dispatch(searchAppExclusion(label, exe, description, fireSearchSuccess, fireSearchFailure))
  }

  // app exclusion is already in db
  const fireSearchSuccess = () => {
    NotificationToast(true, 'This app has already been added.')
  }
  // app exclusion is not already in db
  const fireSearchFailure = async (label, exe, description) => {
    await dispatch(postAppExclusion(label, exe, description, fireAddSuccess, fireAddFailure))
    await dispatch(getAppExclusions())
  }
  const fireAddSuccess = () => {
    NotificationToast(false, 'Successfully added new app exclusion!')
  }

  const fireAddFailure = () => {
    NotificationToast(true, 'Failed to add app exclusion.')
  }

  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Successfully Deleted Application Exclusion!')
    dispatch(getAppExclusions())
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to Delete Application Exclusion.')
  }

  const removeApplication = async (exclusionID) => {
    const deleteStat = await ConfirmToast({ msg: 'Are you sure you want to delete this application exclusion?' })
    if (deleteStat === true) {
      dispatch(deleteAppExclusion(exclusionID, fireDeleteSuccess, fireDeleteFailure))
    }
  }

  const isEnabled = newApplicationLabel.length > 0 && newApplicationExe.length > 0

  function renderAppExclusions () {
    return (
      <Grid item container direction='row'>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row'>
            <Grid item container direction='column' sm={6}>
              <h2 className='mr-3 mb-4'>
                App Exclusions
              </h2>
            </Grid>
            <Grid item container direction='column' sm={6} className='mt-2'>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <Fab
                    className={classes.searchBtn}
                    size='small'
                  >
                    <SearchIcon />
                  </Fab>
                </div>
                <InputBase
                  placeholder='App Name'
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput
                  }}
                  inputProps={{ 'aria-label': 'search' }}
                  onChange={(e) => {
                    setSearchVal(e.target.value)
                  }}
                  value={searchVal}
                  endAdornment={
                    searchVal !== ''
                      ? (
                        <InputAdornment position='start'>
                          <IconButton onClick={() => setSearchVal('')}>
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ) : (<></>)
                  }
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' justify='center' className='mt-2'>
            <Grid item container direction='column' sm={3} className='mr-2'>
              <h5>Label</h5>
              <TextField
                value={newApplicationLabel}
                onChange={e => setNewApplicationLabel(e.target.value)}
                placeholder='Label'
                name='newApplicationLabel'
                id='newApplicationLabel'
                error={newApplicationLabel.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={3} className='mr-2'>
              <h5>Application</h5>
              <TextField
                value={newApplicationExe}
                onChange={e => setNewApplicationExe(e.target.value)}
                placeholder='Application'
                name='newApplicationExe'
                id='newApplicationExe'
                error={newApplicationExe.length === 0}
                required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={3} className='mr-2'>
              <h5>Description</h5>
              <TextField
                value={newApplicationDescription}
                onChange={e => setNewApplicationDescription(e.target.value)}
                placeholder='Description'
                name='newApplicationDescription'
                id='newApplicationDescription'
                // error={newApplicationDescription.length === 0}
                // required
                InputProps={{ classes: textClasses }}
                fullWidth
                variant='filled'
              />
            </Grid>

            <Grid item container direction='column' sm={2}>
              <Button
                className={`${classes.greenBtn}`}
                onClick={(e) => { e.preventDefault(); addApplication(newApplicationLabel, newApplicationExe, newApplicationDescription) }}
                variant='contained'
                disabled={!isEnabled}
              >
                <span className='font-weight-bold'>Add New</span>
              </Button>
            </Grid>
          </Grid>
          <Grid item container direction='row' justify='center' className={classes.appContainer}>
            <Grid item container direction='column'>
              {selectedExclusions.filter((currentApp) => {
                return currentApp.applicationName.toLowerCase().includes(searchVal.toLowerCase()) ||
                currentApp.applicationEXE.toLowerCase().includes(searchVal.toLowerCase())
              }).map((currentApp, i) => (
                <Grid item container direction='row' justify='center' key={`app-${i}`} className='mx-auto my-2 w-98'>
                  <Card raised className={classes.roleCard}>
                    <CardContent>
                      <Grid item container direction='row'>
                        <Grid item container direction='column' sm={5} className='ml-2 mt-2'>
                          <Grid item container direction='row'>
                            <FormLabel>Label:</FormLabel>
                          </Grid>
                          <Grid item container direction='row'>
                            <h5 style={{ fontWeight: 'bold', color: '#007bff' }}>{currentApp.applicationName}</h5>
                          </Grid>
                        </Grid>
                        <Grid item container direction='column' sm={5} className='mt-2'>
                          <Grid item container direction='row'>
                            <FormLabel>Application:</FormLabel>
                          </Grid>
                          <Grid item container direction='row'>
                            <h5>{currentApp.applicationEXE}</h5>
                          </Grid>
                        </Grid>
                        <Grid item container direction='column' sm={1}>
                          <Button
                            className={`${classes.deleteBtn} my-2 ml-4`}
                            variant='contained'
                            onClick={(e) => { e.preventDefault(); removeApplication(currentApp.exclusionID) }}
                          >
                            Delete
                          </Button>
                        </Grid>
                        {
                          currentApp.applicationDesc
                            ? (
                              <>
                                <Grid item container direction='column' sm={12} className='mt-2 ml-1'>
                                  <Grid item container direction='row'>
                                    <FormLabel>App Description:</FormLabel>
                                  </Grid>
                                  <Grid item container direction='row'>
                                    <h5>{currentApp.applicationDesc}</h5>
                                  </Grid>
                                </Grid>
                              </>
                            ) : (
                              <>
                              </>
                            )
                        }
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      {renderAppExclusions()}
    </>
  )
}

export default AppExclusionList
